<template>
  <header class="pacient-header">

    <span class="breadcrumb">home > pacienti > #{{ pacient.id }} ({{ moment(new Date(pacient.createdAt)).format('DD MMM YYYY') }})</span>

    <div class="flex flex-between">
      <figure class="avatar flex align-center">

        <div class="preview-avatar flex-center"
             v-if="avatarPic">
          <img :class="{pointer: $router.currentRoute.name === 'edit'}"
               :src="avatarPic"
               @click="showPic"
               alt="">
        </div>

        <div v-else>
          <label class="pointer"
                 for="upload-avatar">
            <img class="opa4"
                 src="../assets/user.svg"
                 alt="user avatar">
          </label>

          <input class="absolute"
                 id="upload-avatar"
                 @change="uploadFile"
                 type="file">
        </div>

        <div class="flex-center">
          <span class="uppercase opa5">{{ pacient.nume }} {{ pacient.prenume }}</span>
        </div>

      </figure>
      <div class="upload flex"
           v-show="pacient.id">

        <div v-if="user.rol && !user.rol.includes('asistent')"
             id="fisa-scrisoare-module">

          <i class="block-user pointer"
             :class="{ 'block-user-activ': pacient.blocked }"
             @click="blockPacient"
             v-html="svg.blockPacient"></i>

          <i class="pointer"
             @click="printFisaPacient">
            <svg width="30px" height="40px" viewBox="0 0 30 40">
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <path d="M29.1796875,11.796875 L18.3203125,0.8203125 C18.1987841,0.716145312 18.07147,0.617766146 17.9383683,0.525173727 L17.734375,0.390625 C17.6562496,0.338541406 17.6041668,0.3125 17.578125,0.3125 C17.5520832,0.286458203 17.5130211,0.260416797 17.4609375,0.234375 C17.0963523,0.0781242188 16.718752,0 16.328125,0 L2.8515625,0 C2.07030859,0 1.39974238,0.273434766 0.83984375,0.8203125 C0.279945117,1.36719023 0,2.03124609 0,2.8125 L0,37.1875 C0,37.9687539 0.279945117,38.6328098 0.83984375,39.1796875 C1.39974238,39.7265652 2.07030859,40 2.8515625,40 L27.1875,40 C27.9687539,40 28.6262994,39.7265652 29.1601562,39.1796875 C29.6940131,38.6328098 29.9609375,37.9687539 29.9609375,37.1875 L29.9609375,13.75 C29.9609375,12.9687461 29.7005234,12.3177109 29.1796875,11.796875 Z M17.7734375,4.296875 L25.625,12.1875 L17.7734375,12.1875 L17.7734375,4.296875 Z M27.1484375,37.1875 L2.8125,37.1875 L2.8125,2.8125 L14.9609375,2.8125 L14.9609375,12.1875 C14.9609375,12.9687539 15.2408826,13.6328098 15.8007812,14.1796875 C16.3606799,14.7265652 17.0312461,15 17.8125,15 L27.1484375,15 L27.1484375,37.1875 Z M8.0078125,22.5 L5.390625,22.5 L5.390625,30 L7.1875,30 L7.1875,27.5 L8.046875,27.5 C8.9062543,27.5 9.61588262,27.2851584 10.1757812,26.8554688 C10.7356799,26.4257791 11.015625,25.7812543 11.015625,24.921875 C11.015625,23.3072836 10.0130309,22.5 8.0078125,22.5 Z M7.96875,26.09375 L7.1875,26.09375 L7.1875,23.90625 L7.890625,23.90625 C8.80208789,23.90625 9.2578125,24.2447883 9.2578125,24.921875 C9.2578125,25.7031289 8.8281293,26.09375 7.96875,26.09375 Z M14.453125,22.5 L12.265625,22.5 L12.265625,30 L14.53125,30 C15.6770891,30 16.5755176,29.6809928 17.2265625,29.0429688 C17.8776074,28.4049447 18.203125,27.4609437 18.203125,26.2109375 C18.203125,24.9609313 17.8710971,24.029951 17.2070312,23.4179688 C16.5429654,22.8059865 15.6250059,22.5 14.453125,22.5 Z M14.3359375,28.5546875 L14.1015625,28.5546875 L14.1015625,23.9453125 L14.3359375,23.9453125 C14.9869824,23.9453125 15.4882795,24.1145816 15.8398438,24.453125 C16.191408,24.7916684 16.3671875,25.3776 16.3671875,26.2109375 C16.3671875,27.7734453 15.6901109,28.5546875 14.3359375,28.5546875 Z M24.375,23.984375 L21.40625,23.984375 L21.40625,25.6640625 L23.9453125,25.6640625 L23.9453125,27.1484375 L21.40625,27.1484375 L21.40625,30 L19.609375,30 L19.609375,22.5 L24.375,22.5 L24.375,23.984375 Z" id="" fill="#2ABB9C" fill-rule="nonzero"></path>
              </g>
            </svg>
          </i>

          <i class="pointer"
             @click="makeScrisoareMedicala">
            <svg width="30px" height="40px" viewBox="0 0 30 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <path d="M29.1796875,11.796875 L18.3203125,0.8203125 C18.1987841,0.716145312 18.07147,0.617766146 17.9383683,0.525173727 L17.734375,0.390625 C17.6562496,0.338541406 17.6041668,0.3125 17.578125,0.3125 C17.5520832,0.286458203 17.5130211,0.260416797 17.4609375,0.234375 C17.0963523,0.0781242188 16.718752,0 16.328125,0 L2.8515625,0 C2.07030859,0 1.39974238,0.273434766 0.83984375,0.8203125 C0.279945117,1.36719023 0,2.03124609 0,2.8125 L0,37.1875 C0,37.9687539 0.279945117,38.6328098 0.83984375,39.1796875 C1.39974238,39.7265652 2.07030859,40 2.8515625,40 L27.1875,40 C27.9687539,40 28.6262994,39.7265652 29.1601562,39.1796875 C29.6940131,38.6328098 29.9609375,37.9687539 29.9609375,37.1875 L29.9609375,13.75 C29.9609375,12.9687461 29.7005234,12.3177109 29.1796875,11.796875 Z M17.7734375,4.296875 L25.625,12.1875 L17.7734375,12.1875 L17.7734375,4.296875 Z M27.1484375,37.1875 L2.8125,37.1875 L2.8125,2.8125 L14.9609375,2.8125 L14.9609375,12.1875 C14.9609375,12.9687539 15.2408826,13.6328098 15.8007812,14.1796875 C16.3606799,14.7265652 17.0312461,15 17.8125,15 L27.1484375,15 L27.1484375,37.1875 Z M8.0078125,22.5 L5.390625,22.5 L5.390625,30 L7.1875,30 L7.1875,27.5 L8.046875,27.5 C8.9062543,27.5 9.61588262,27.2851584 10.1757812,26.8554688 C10.7356799,26.4257791 11.015625,25.7812543 11.015625,24.921875 C11.015625,23.3072836 10.0130309,22.5 8.0078125,22.5 Z M7.96875,26.09375 L7.1875,26.09375 L7.1875,23.90625 L7.890625,23.90625 C8.80208789,23.90625 9.2578125,24.2447883 9.2578125,24.921875 C9.2578125,25.7031289 8.8281293,26.09375 7.96875,26.09375 Z M14.453125,22.5 L12.265625,22.5 L12.265625,30 L14.53125,30 C15.6770891,30 16.5755176,29.6809928 17.2265625,29.0429688 C17.8776074,28.4049447 18.203125,27.4609437 18.203125,26.2109375 C18.203125,24.9609313 17.8710971,24.029951 17.2070312,23.4179688 C16.5429654,22.8059865 15.6250059,22.5 14.453125,22.5 Z M14.3359375,28.5546875 L14.1015625,28.5546875 L14.1015625,23.9453125 L14.3359375,23.9453125 C14.9869824,23.9453125 15.4882795,24.1145816 15.8398438,24.453125 C16.191408,24.7916684 16.3671875,25.3776 16.3671875,26.2109375 C16.3671875,27.7734453 15.6901109,28.5546875 14.3359375,28.5546875 Z M24.375,23.984375 L21.40625,23.984375 L21.40625,25.6640625 L23.9453125,25.6640625 L23.9453125,27.1484375 L21.40625,27.1484375 L21.40625,30 L19.609375,30 L19.609375,22.5 L24.375,22.5 L24.375,23.984375 Z" id="" fill="#FF9C60" fill-rule="nonzero"></path>
              </g>
            </svg>
          </i>
        </div>

        <div class="antecedente flex"
             :class="{'has-antecedente': alergii}">
          <span>ALERGII</span>
          <i v-html="svg.caution"></i>
        </div>

        <div class="antecedente flex"
             :class="{'has-antecedente': antecedente}">
          <span>ANTECEDENTE</span>
          <i v-html="svg.caution"></i>
        </div>

      </div>
    </div>
    <div class="toggle-feedback-container">
      <div class="feedback-row">
        <FeedBack_Toggle/>
      </div>
      <div class="feedback-lang-selector">
        <label class="lang-option">
          <input
            type="radio"
            name="feedback_lang"
            value="RO"
            v-model="selectedLang">
          <span>RO</span>
        </label>
        <label class="lang-option">
          <input
            type="radio"
            name="feedback_lang"
            value="EN"
            v-model="selectedLang">
          <span>EN</span>
        </label>
      </div>
    </div>

    <div v-if="history"
         class="filtre flex">
      <div class="filtru-medic">
        <drop-down :data="ddMedici" />
      </div>

      <div class="filtru-dinte">
        <drop-down :data="ddDinte" />
      </div>

      <button class="bg-transparent noborder"
              data-test="clear-filter-tratamente"
              :class="{ pointer: dinte || medic }"
              :disabled="!dinte && !medic">
        <i v-html="svg.closeGray"
           :class="{ 'active-close': dinte || medic }"
           @click="resetFiltre"></i>
      </button>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import 'moment/locale/ro'
import { EventBus } from '../main.js'
import FeedBack_Toggle from "@/components/FeedBack_Toggle.vue";
import {formatRomanianDate} from "@/mixins/utils";
moment.locale('ro')

export default {
  name: 'pacient-header',
  components: { FeedBack_Toggle },
  data () {
    return {
      medic: undefined,
      dinte: undefined,
      ddMedici: {
        name: 'medic',
        placeholder: 'medic',
        ddData: 'medici',
        validation: false,
        disabled: false,
        clbk: medic => {
          this.ddDinte.disabled = true
          this.medic = medic
          this.$store.commit('FILTER_TRATAMENTE_HISTORY', {
            dinte: this.dinte,
            medic
          })
        }
      },
      ddDinte: {
        name: 'dinte',
        placeholder: 'dinte',
        ddData: 'dinti',
        validation: false,
        disabled: false,
        clbk: dinte => {
          this.dinte = dinte
          this.ddMedici.disabled = true
          this.$store.commit('FILTER_TRATAMENTE_HISTORY', {
            dinte,
            medic: this.medic
          })
        }
      },
      formData: new FormData(),
      acceptedFiles: ['.jpg', '.JPG', '.jpeg', '.png', '.bmp', '.gif', '.heic', '.HEIC'],
      moment
    }
  },

  created () {
    const id = this.$router.currentRoute.params.id
    id && this.$store.dispatch('get_patient', { id })
    this.$store.dispatch('get_medici')
  },

  computed: {
    ...mapState({
      antecedente: 'antecedente',
      alergii: 'alergii',
      pacient: 'pacient',
      svg: 'svg',
      avatarPic: 'avatarPic',
      user: 'user',

    }),
    edit () {
      return this.$router.currentRoute.name === 'edit'
    },
    history () {
      return this.$router.currentRoute.name === 'history'
    },
    selectedLang: {
      get () {
        return this.$store.state.pacient.feedback_lang || 'RO'
      },
      set (lang) {
        this.$store.dispatch('update_pacient', { feedback_lang: lang })
      }
    }
  },


  methods: {
    blockPacient () {
      this.$store.dispatch('block_pacient')
    },
    uploadFile (ev) {
      const file = ev.currentTarget.files[0]
      const re = /\.[0-9a-z]+$/i
      const extension = re.exec(file.name)[0]
      if (this.acceptedFiles?.includes(extension)) {
        this.formData.append('file', file)
        this.formData.append('id', this.$router.currentRoute.params.id)
        this.$store.dispatch('upload_avatar', this.formData)
        this.formData = new FormData()
      } else {
        alert('Format document nesuportat.')
      }
    },

    showPic () {
      const obj = {
        name: 'avatar',
        val: true
      }
      this.$router.currentRoute.name === 'edit' && this.$store.commit('SET_MODAL', obj)
    },

    makeScrisoareMedicala () {
      this.$store.commit('SET_KEY_VALUE', {
        key: 'printComponentName',
        value: 'scrisoareMedicala'
      })
      this.$store.commit('SET_KEY_VALUE', {
        key: 'textScrisoare',
        value: ''
      })
      const obj = {
        val: true,
        name: 'scrisoareMedicalaModal'
      }
      this.$store.commit('SET_MODAL', obj)
    },

    printFisaPacient () {
      window.print()
    },

    resetFiltre () {
      this.$store.commit('CLEAR_FILTER_TRATAMENTE')
      EventBus.$emit('reset-dd-model', { name: 'medic' })
      EventBus.$emit('reset-dd-model', { name: 'dinte' })
      this.medic = undefined
      this.dinte = undefined
      this.ddMedici.disabled = false
      this.ddDinte.disabled = false
    }
  }
}
</script>

<style lang="less">
  @import "../assets/styles/var";
  .pacient-header {
    padding-top: 24px;
    .breadcrumb  + div.flex.flex-between {
      margin: 16px 0 0 0;
      justify-content: space-between;
      align-items: flex-end;
    }
    .toggle-feedback-container {
      padding-bottom: 25px;
      padding-left: 42px;
      .feedback-lang-selector {
        display: flex;
        align-items: center;
        padding-left: 60px;
        gap: 10px;
        margin-top: 5px;
        .lang-option {
          display: flex;
          align-items: center;
          gap: 2px;
          cursor: pointer;

          input[type="radio"] {
            appearance: none;
            -webkit-appearance: none;
            width: 15px;
            height: 15px;
            min-width: 15px;
            border: 2px solid #696969;
            border-radius: 50%;
            cursor: pointer;
            position: relative;

            &:checked {
              border: 2px solid @main-green !important;

              &::after {
                content: '';
                position: absolute;
                width: 6px;
                height: 6px;
                background: @main-green;
                border-radius: 50%;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              }
            }
          }

          > span {
            font-size: 15px;
            color: #696969;
            transform: translateY(3px);
          }

          &:has(input:checked) > span {
            color: @main-green;
            font-weight: bold;
          }
        }
      }
    }
    .avatar {
      .preview-avatar {
        width: 41px;
        height: 41px;
        margin-right: 16px;
        overflow: hidden;
        border-radius: 50%;
        img {
          height: 100%;
        }
      }
      label img {
        width: 41px;
        margin-right: 16px;
      }
      input {
        width: 0;
        height: .1px;
        visibility: hidden;
      }

      font-size: 2.2rem;
    }

    .upload {
      i {
        height: 40px;
        padding: 0 8px;
        display: inline-block;
      }
      & > div.flex-center {
        margin-left: 20px;
        margin-top: 8px;
      }
    }

    .antecedente {
      margin-left: 20px;
      align-items: flex-end;
      i {
        height: 33px;
        padding: 0;
        svg {
          transform: scale(.6);
        }
      }
      span {
        font-size: 1.4rem;
        opacity: .4;
      }
    }

    .has-antecedente {
      color: @red;
      span {
        opacity: 1;
      }
      #caution-icon {
        fill: @red;
      }
    }

    div.filtre {
      margin-bottom: 16px;
      & > div {
        width: 240px;
        input {
          padding-left: 20px;
        }
      }

      .filtru-medic {
        margin: 0 16px 0 auto;
      }

      .filtru-dinte {
        margin-right: 8px;
      }

      i.active-close svg {
        path {
          fill: @main-green;
        }
      }
      i.active-close svg:hover {
        path {
          fill: darken(@main-green, 20%, relative);
        }
      }
    }

    .block-user {
      height: 40px;
    }

    .block-user-activ {
      svg path {
        fill: red;
      }
    }
  }
</style>
